module.exports = __webpack_public_path__ + "img/黑桃初级大师@3x.aae868eb.png";